// Global packages and components
import { videoClasses } from '~/utils'
import { Video } from '~/components'

// Types
import type {
  SanityCustomFile,
  VideoBlockRatios,
  VideoBlockMobileRatios,
  VideoBlockTypes,
  SanityRefWithAlt,
} from '~/types'

type VideoProps = {
  videoRatio?: VideoBlockRatios
  mobileVideoRatio?: VideoBlockMobileRatios
  videoType: VideoBlockTypes
  videoTitle?: string
  file?: SanityCustomFile
  mobileFile?: SanityCustomFile
  oembed?: string
  mobileOembed?: string
  poster?: SanityRefWithAlt
}

// Main export
export default function BlockVideo({
  videoRatio,
  mobileVideoRatio,
  videoType,
  videoTitle,
  file,
  mobileFile,
  oembed,
  mobileOembed,
  poster,
}: VideoProps) {
  return (
    <div
      className={videoClasses({
        videoRatio,
        mobileVideoRatio,
        videoType,
        mobileFile,
        mobileOembed,
      })}
    >
      <div className="h-full overflow-hidden rounded-2xl">
        <Video
          videoType={videoType}
          videoTitle={videoTitle}
          file={file}
          mobileFile={mobileFile}
          oembed={oembed}
          mobileOembed={mobileOembed}
          poster={poster}
        />
      </div>
    </div>
  )
}
